import { any } from 'joi';
import { PaginateList } from '../../../common/types/common-types';
import { AgencyCampaignTypeStatusEnum } from '../constants';
import { TimeSetting } from './common-types';
import { Lead } from '../../Leads/types/types';

export enum CampaignFormMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export enum CampaignDetailPageStep {
  CAMPAIGN_INFO = 1,
  PARTICIPANT = 2,
  ATTACHMENT = 3,
  APPROVAL = 4,
  EVNET_DOCUMENT = 5,
  LEAD = 6,
}

export type louItem = {
  isRequired: boolean;
  dayBeforeSend: number;
  sendTypes: string[];
  resourceIds: string[];
};

export type campaignSectionFieldItem = {
  key: string;
  title: string;
  type: string;
  value: string | string[] | any[];
  priority: number;
  rules: any[];
  isActive: boolean;
  isRequired: boolean;
  options: any;
};

export type campaignStructureSection = {
  priority: number;
  sectionFields: campaignSectionFieldItem[];
  key: string;
  title: string;
};

export type ApprovalSettingItem = {
  labelName: string;
  selectBy: string;
  roleList: {
    type: string;
    values: string[];
  };
};

export type AddLeadSettingItem = {
  selfAddEnabled: string | boolean;
  needACMApproved: boolean;
  startDateSetting: TimeSetting;
  endDateSetting: TimeSetting;
  startDate: Date;
  endDate: Date;
};

export type CampaignStructureItem = {
  _id: string;
  role?: string[];
  name: string;
  code: string;
  isActive: boolean;
  agentLeadSource?: string;
  agentLeadSubSource?: string[];
  lou: louItem;
  timezone: number;
  workflowTemplateId: string;
  sections: campaignStructureSection[];
  createdAt: Date;
  updatedAt: Date;
  approvalSetting: ApprovalSettingItem[];
  addLeadSetting: AddLeadSettingItem;
};

export type CampaignListParam = {
  limit: number;
  page: number;
  status?: AgencyCampaignTypeStatusEnum[];
  campaignType?: string[];
  name: string;
};

export type CampaignItem = {
  campaignId: string;
  type?: string;
  startDate?: Date;
  endDate?: Date;
  name?: string;
  createdAt?: Date;
  updatedAt?: Date;
  createdBy?: string;
  updatedBy?: string;
  status?: string;
  agencyCampaign?: { typeId: CampaignTypeItem; rsvpStatus: string };
  image: { url: string } | null;
  lastViewedTime: string;
};

export type CampaignTypeItem = {
  _id: string;
  name: string;
  status: string;
};

export type AgentItem = {
  unit?: string;
  name?: any;
  agentCode: string;
  displayName?: any;
  rsvpIndicator?: string;
  invitationTime?: string;
};

export type AgentListParam = {
  limit: number;
  page: number;
  search: string;
  id?: string;
};

export type LeadUploadItem = {
  campaignId: string;
  resourceId: string;
  filename: string;
};

export type CampaignDetailItem = any;

export type CampaignPaginateList = PaginateList<CampaignItem>;

export type AgentPaginateList = PaginateList<AgentItem>;

export type DownlineVerifyList = { downline: AgentItem[]; exclude: String[] };

export type FailAgentItem = {
  agentCode: string;
  notEligibleReason: string;
  isEligible: boolean;
  businessName?: string;
  unitCode?: string;
};
export type SuccessAgentItem = {
  agentCode: string;
  notEligibleReason: string;
  isEligible: boolean;
  agency: string;
  unit: string;
};
export type NonDownlineVerifyList = { fail?: FailAgentItem[]; success?: SuccessAgentItem[] };
export type ImportVerify = { agentCodeArr: string[]; campaignID: string; campaignTypeID: string; rules: string[] };

export interface CampaignLead {
  _id: string;
  labels: string[];
  expiredAt: string;
  leadSource: string;
  followUpStatus: string;
  image: { url?: string };
  followUp: Array<{ status: string; reason?: string }>;
  description: string;
  agentStatus: string;
  updatedAt: string;
  lastViewedAt: string;
  issuedPolicy: Array<{ policyNumber: string }>;
  campaign: {
    name: string;
  };
  prospect: {
    displayName: string;
    firstName: string;
    lastName: string;
    types: Array<string>;
  };
}

export interface CampaignLeadResponse {
  docs: Lead[];
  totalDocs: number;
  limit: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNextPage: boolean;
  prevPage: number | null;
  nextPage: number | null;
}

export enum ProspectTypes {
  prospect_type_customer = 'prospect_type_customer',
  prospect_type_non_customer = 'prospect_type_non_customer',
  prospect_type_candidate = 'prospect_type_candidate',
  prospect_type_non_candidate = 'prospect_type_non_candidate',
  prospect_type_agent = 'prospect_type_agent',
}

export enum ProspectSourceTypes {
  prospect_source_marketing = 'prospect_source_marketing',
  prospect_source_agent = 'prospect_source_agent',
}

export enum RsvpStatus {
  Pending = 'Pending',
  Accepted = 'Accepted',
  Rejected = 'Rejected',
}

interface Division {
  code: string;
  description: string;
}

export interface DisplayName {
  zhHk: string;
  enUs: string;
}
export interface AgentData {
  agentCode: string;
  agency: string;
  branch: string;
  unit: string;
  group: string;
  division: Division;
  displayName: DisplayName;
}
